import React from 'react';
import './ShippingPolicy.css';

function ShippingPolicy() {
  return (
    <div className="shipping-policy-page">
      {/* Hero Section with Background Image */}
      <section className="policy-hero">
        <div className="hero-image-overlay">
          <div className="container">
            <div className="hero-content">
              <div className="hero-badge">
                <span className="badge-icon">📦</span>
                <span className="badge-text">SHIPPING INFORMATION</span>
              </div>
              <h1>SHIPPING POLICY</h1>
              <p className="hero-subtitle">The Shapes United Shipping Policy</p>
              <div className="hero-features">
                <div className="feature">
                  <span className="feature-icon">🚚</span>
                  <span className="feature-text">Fast & Reliable Delivery</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">🌏</span>
                  <span className="feature-text">Worldwide Shipping</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">📱</span>
                  <span className="feature-text">Real-Time Tracking</span>
                </div>
              </div>
              <div className="last-updated">
                <span className="update-badge">📅</span>
                <span className="update-text">Last updated on 28th September 2022</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Info Cards */}
      <section className="quick-info">
        <div className="container">
          <div className="info-cards">
            <div className="info-card">
              <div className="card-icon">⏱️</div>
              <div className="card-content">
                <h3>Processing Time</h3>
                <p>2-3 business days</p>
              </div>
            </div>
            <div className="info-card">
              <div className="card-icon">🚚</div>
              <div className="card-content">
                <h3>Shipping Partners</h3>
                <p>FedEx & Sendle</p>
              </div>
            </div>
            <div className="info-card">
              <div className="card-icon">💰</div>
              <div className="card-content">
                <h3>Free Shipping</h3>
                <p>Available on all orders</p>
              </div>
            </div>
            <div className="info-card">
              <div className="card-icon">📱</div>
              <div className="card-content">
                <h3>Order Tracking</h3>
                <p>24-hour tracking updates</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="policy-content">
        <div className="container">
          <div className="content-wrapper">
            {/* Introduction Card */}
            <div className="intro-card">
              <div className="intro-icon">👋</div>
              <div className="intro-text">
                <h2>Welcome to Our Shipping Policy</h2>
                <p>
                  Thank you for visiting and shopping at www.theshapesunited.com. 
                  The following terms and conditions constitute our Shipping Policy.
                </p>
              </div>
            </div>

            {/* Interpretation & Definitions with Visual Design */}
            <section className="policy-section definition-section">
              <div className="section-header with-image">
                <div className="header-image">
                  <img 
                    src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
                    alt="Legal Documents"
                  />
                </div>
                <div className="header-content">
                  <h2>INTERPRETATION AND DEFINITIONS</h2>
                  <p className="section-subtitle">Legal terminology and definitions used in this policy</p>
                </div>
              </div>

              <div className="definition-grid">
                <div className="definition-card">
                  <div className="def-icon">📖</div>
                  <h3>INTERPRETATION</h3>
                  <p>
                    The words of which the initial letter is capitalized have meanings defined under the 
                    following conditions. The following definitions shall have the same meaning regardless 
                    of whether they appear in singular or in plural.
                  </p>
                </div>

                <div className="definition-card">
                  <div className="def-icon">📚</div>
                  <h3>DEFINITIONS</h3>
                  <div className="def-list">
                    <div className="def-item">
                      <span className="def-term">"Company"</span>
                      <span className="def-meaning">(referred to as either "the Company", "We", "Us" or "Our" in this Disclaimer) refers to The Shapes United</span>
                    </div>
                    <div className="def-item">
                      <span className="def-term">"Goods"</span>
                      <span className="def-meaning">refers to the items offered for sale on the Service.</span>
                    </div>
                    <div className="def-item">
                      <span className="def-term">"Orders"</span>
                      <span className="def-meaning">means a request by You to purchase Goods from Us.</span>
                    </div>
                    <div className="def-item">
                      <span className="def-term">"Service"</span>
                      <span className="def-meaning">refers to the Website.</span>
                    </div>
                    <div className="def-item">
                      <span className="def-term">"Website"</span>
                      <span className="def-meaning">refers to com accessible from https://www.theshapesunited.com</span>
                    </div>
                    <div className="def-item">
                      <span className="def-term">"You"</span>
                      <span className="def-meaning">means the individual accessing the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Domestic Shipping Policy */}
            <section className="policy-section shipping-section">
              <div className="section-header">
                <h2>DOMESTIC SHIPPING POLICY</h2>
                <p className="section-subtitle">Shipping within USA & Australia</p>
              </div>

              {/* Shipment Processing */}
              <div className="subsection with-icon">
                <div className="subsection-icon">⏳</div>
                <div className="subsection-content">
                  <h3>SHIPMENT PROCESSING TIMES</h3>
                  <p>
                    All Orders are processed within 2-3 business days. Orders are not shipped or delivered on weekends or holidays.
                  </p>
                  <div className="note-box">
                    <div className="note-icon">ℹ️</div>
                    <div className="note-text">
                      If We are experiencing a high volume of orders, shipments may be delayed by a few days. 
                      Please allow additional days in transit for delivery. If there will be a significant delay 
                      in shipment of Your Order, We will contact You via email or telephone.
                    </div>
                  </div>
                </div>
              </div>

              {/* Shipping Rates Table */}
              <div className="subsection">
                <h3>SHIPPING RATES & DELIVERY ESTIMATES</h3>
                <p>
                  Shipping charges for Your Orders will be calculated and displayed at checkout.
                </p>
                
                <div className="shipping-table">
                  <div className="table-header">
                    <div className="table-col method">Shipping Method</div>
                    <div className="table-col cost">Shipment Cost</div>
                    <div className="table-col time">Estimated Delivery Time</div>
                  </div>
                  
                  <div className="table-row">
                    <div className="table-col method">
                      <div className="method-name">FedEx Standard in USA and Sendle in AU</div>
                    </div>
                    <div className="table-col cost free">Free</div>
                    <div className="table-col time">3-5 business days</div>
                  </div>
                  
                  <div className="table-row">
                    <div className="table-col method">
                      <div className="method-name">FedEx Two Days in USA and Sendle in AU</div>
                    </div>
                    <div className="table-col cost">$12.95 USD</div>
                    <div className="table-col time">2 business days</div>
                  </div>
                  
                  <div className="table-row">
                    <div className="table-col method">
                      <div className="method-name">FedEx Standard in USA and Sendle in AU</div>
                    </div>
                    <div className="table-col cost">$19.95 USD</div>
                    <div className="table-col time">1-2 business days</div>
                  </div>
                </div>
                
                <div className="info-box">
                  <p>
                    <strong>Note:</strong> Overnight delivery is only available for Orders with delivery 
                    addresses within the continental United States and Australia.
                  </p>
                  <p className="warning-text">⚠️ Delivery delays can occasionally occur.</p>
                </div>
              </div>

              {/* Shipment to PO Boxes */}
              <div className="subsection">
                <h3>SHIPMENT TO P.O. BOXES OR APO/FPO ADDRESSES</h3>
                <div className="address-box">
                  <div className="address-icon">📮</div>
                  <div className="address-text">
                    www.theshapesunited.com ships to addresses within the U.S., U.S. Territories, 
                    Australian states and APO/FPO/DPO addresses.
                  </div>
                </div>
              </div>

              {/* Shipment Confirmation */}
              <div className="subsection">
                <h3>SHIPMENT CONFIRMATION & ORDER TRACKING</h3>
                <div className="tracking-flow">
                  <div className="flow-step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h4>Order Placed</h4>
                      <p>You place your order</p>
                    </div>
                  </div>
                  <div className="flow-arrow">→</div>
                  <div className="flow-step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h4>Order Processed</h4>
                      <p>Within 2-3 business days</p>
                    </div>
                  </div>
                  <div className="flow-arrow">→</div>
                  <div className="flow-step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h4>Shipment Confirmation</h4>
                      <p>Email with tracking number</p>
                    </div>
                  </div>
                  <div className="flow-arrow">→</div>
                  <div className="flow-step">
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <h4>Track Your Order</h4>
                      <p>Active within 24 hours</p>
                    </div>
                  </div>
                </div>
                <p className="tracking-note">
                  You will receive a Shipment Confirmation Email once Your Order has shipped containing 
                  your tracking number(s). The tracking number will be active within 24 hours.
                </p>
              </div>
            </section>

            {/* International Shipping Section */}
            <section className="policy-section international-section">
              <div className="section-header with-image">
                <div className="header-image">
                  <img 
                    src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
                    alt="Global Shipping"
                  />
                </div>
                <div className="header-content">
                  <h2>CUSTOMS, DUTIES AND TAXES</h2>
                  <p className="section-subtitle">Important information for international orders</p>
                </div>
              </div>

              <div className="warning-card">
                <div className="warning-icon">⚠️</div>
                <div className="warning-content">
                  <h3>International Responsibility</h3>
                  <p>
                    www.theshapesunited.com is not responsible for any customs and taxes applied to Your Order. 
                    All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes).
                  </p>
                  <div className="international-tips">
                    <div className="tip">
                      <span className="tip-icon">💡</span>
                      <span>Check local customs regulations before ordering</span>
                    </div>
                    <div className="tip">
                      <span className="tip-icon">💡</span>
                      <span>Factor in potential duties when budgeting</span>
                    </div>
                    <div className="tip">
                      <span className="tip-icon">💡</span>
                      <span>Contact local customs for specific information</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Damages Section */}
            <section className="policy-section damages-section">
              <div className="section-header">
                <h2>DAMAGES</h2>
                <p className="section-subtitle">Procedure for damaged goods</p>
              </div>

              <div className="damage-process">
                <div className="damage-card">
                  <div className="damage-icon">📦</div>
                  <div className="damage-content">
                    <h3>Damage During Shipping</h3>
                    <p>
                      www.theshapesunited.com is not liable for any products damaged or lost during shipping. 
                      If You received Your Order damaged, please contact the shipment carrier to file a claim.
                    </p>
                  </div>
                </div>

                <div className="important-notice">
                  <div className="notice-icon">🔴</div>
                  <div className="notice-content">
                    <h4>Important Notice</h4>
                    <p>
                      Please save all packaging materials and damaged goods before filing a claim.
                      This is essential for the claims process with the shipping carrier.
                    </p>
                    <div className="notice-actions">
                      <a href="/contact" className="action-link">Contact Support</a>
                      <a href="/faqs" className="action-link">View FAQ</a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Contact CTA */}
            <section className="contact-cta">
              <div className="cta-content">
                <div className="cta-icon">💬</div>
                <div className="cta-text">
                  <h2>Need Help with Shipping?</h2>
                  <p>Our support team is here to assist you with any shipping-related questions or concerns.</p>
                </div>
                <div className="cta-actions">
                  <a href="/contact" className="cta-btn">Contact Shipping Support</a>
                  <a href="/faqs" className="cta-btn secondary">View Shipping FAQs</a>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShippingPolicy;